import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { LottieAnimation } from "@/components/common";
import Image from "next/image";
import Link from "next/link";

interface DownloadSectionProps {
  text?: string;
  badgeText?: string;
}

export default function DownloadSection({
  text = "Ready to Turn Every Purchase Into Savings?",
  badgeText = "Get More Repeat Customers For Your Shop",
}: DownloadSectionProps) {
  return (
    <section className="bg-secondary-2 text-white overflow-hidden relative ">
      {/* DOWNLOAD_BG is a near-black animated background (dark circles) -
          this section had no CSS background of its own, so before the
          Lottie loaded (or on a slow connection) its white text rendered
          on the page's default white background: invisible, and measured
          as a 1.04:1 contrast failure. bg-secondary-2 matches the
          animation's own resting color, so there's no visible seam once it
          loads. */}
      <LottieAnimation
        animation="DOWNLOAD_BG"
        loop
        className=" absolute h-full w-full"
      />
      <div className="flex flex-col w-full items-center  h-full  gap-8 px-8 py-10 md:py-16 lg:py-24 relative">
        {/* Badge */}
        <Badge className="whitespace-normal text-center">
          <span className="font-bold text-sm tracking-[0] leading-snug">
            {badgeText}
          </span>
        </Badge>

        {/* Heading */}
        <div className="flex flex-col items-center justify-center gap-2 w-full">
          <h2 className=" lg:max-w-[35rem] sm:max-w-[30rem] max-w-[24rem] text-center">
            {text || `Ready to Turn Every Purchase Into Savings?`}
          </h2>
        </div>

        {/* App store buttons */}
        <div className="flex flex-col sm:flex-row items-center w-[15rem] sm:w-10/12 relative justify-center p-6 gap-3 ">
          {/* Play Store Button */}
          <Link
            href={`https://play.google.com/store/apps/details?id=com.letsdevelopit.lfydcustomer`}
            className="w-full sm:w-auto"
          >
            <Button className="max-w-3xl w-full sm:w-auto">
              <Image
                width={20}
                height={20}
                alt="Google Play icon"
                src="/icons/google-play-fill.svg"
              />
              <span className=""> Download on Playstore</span>
            </Button>
          </Link>
          {/* App Store Button */}
          <Link
            href={`https://apps.apple.com/us/app/fydo/id1612594091`}
            className="w-full sm:w-auto"
          >
            <Button variant="outlineb" className="max-w-3xl w-full sm:w-auto">
              <Image
                width={20}
                height={20}
                alt="Apple icon"
                src="/icons/apple.svg"
              />
              <span className="">Download on Appstore</span>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
